import { render, staticRenderFns } from "./ListCustomer.vue?vue&type=template&id=13560b88&scoped=true"
import script from "./ListCustomer.vue?vue&type=script&lang=js"
export * from "./ListCustomer.vue?vue&type=script&lang=js"
import style0 from "./ListCustomer.vue?vue&type=style&index=0&id=13560b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13560b88",
  null
  
)

export default component.exports